/**
 * Reusable confirmation modal
 */
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const OrderDetailConfirmationModal = ({
  open,
  onCancel,
  title,
  header,
  loading,
  handleConfirm,
}) => {
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{header}</Typography>
      </DialogContent>
      <DialogActions sx={{ marginBottom: "8px", marginRight: "8px" }}>
        <Button variant="contained" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleConfirm}>
          Yes
        </Button>
        {loading && <CircularProgress size={32} />}
      </DialogActions>
    </Dialog>
  );
};

export default OrderDetailConfirmationModal;
